import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ANALYTICS_CONSENT_EVENT, hasAnalyticsConsent } from './CookieBanner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const normalizePath = (pathname) => {
  if (pathname.startsWith('/resultats/')) return '/resultats';
  if (pathname.startsWith('/devis/')) return '/devis';
  if (pathname.startsWith('/suivi/')) return '/suivi';
  return pathname;
};

const AnalyticsTracker = () => {
  const location = useLocation();

  const sendPageView = useCallback(async () => {
    const normalizedPath = normalizePath(location.pathname);
    if (!hasAnalyticsConsent() || normalizedPath.startsWith('/admin') || normalizedPath.startsWith('/pro')) return;

    const eventKey = `ecocasse-audience:${normalizedPath}`;
    if (sessionStorage.getItem(eventKey)) return;

    try {
      const response = await fetch(`${API_URL}/api/analytics/page-views`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Analytics-Consent': 'granted' },
        body: JSON.stringify({ path: normalizedPath }),
        keepalive: true,
      });
      if (response.ok) sessionStorage.setItem(eventKey, 'recorded');
    } catch (error) {
      console.warn('Audience tracking unavailable', error);
    }
  }, [location.pathname]);

  useEffect(() => {
    sendPageView();
    window.addEventListener(ANALYTICS_CONSENT_EVENT, sendPageView);
    return () => window.removeEventListener(ANALYTICS_CONSENT_EVENT, sendPageView);
  }, [sendPageView]);

  return null;
};

export default AnalyticsTracker;